import { Gavel, BadgeCheck, Landmark, HeartHandshake, Scale } from "lucide-react";

export const SOCIAL = {
  facebook: "https://www.facebook.com/dave.graham.35513/",
  instagram: "https://www.instagram.com/davegrahamde/",
};

export const CHECK_INFO = {
  payableTo: "Graham of Delaware, LLC",
  poBox: "P.O. Box 840",
  cityStateZip: "Smyrna, DE 19977-0840",
  maxNote: "The maximum allowable donation by check is $1,200. Every contribution, large or small, is greatly appreciated.",
};

export const SLOGAN = "JUSTICE ★ INTEGRITY ★ ACCOUNTABILITY";
export const PRIMARY_MESSAGE = "PROTECTING DELAWAREANS. RESTORING ACCOUNTABILITY.";
export const DISCLAIMER = "Paid for by Graham of Delaware, LLC";

export const PRIORITIES = [
  {
    id: "violent-offenders",
    icon: Gavel,
    title: "Hold Violent & Repeat Offenders Accountable",
    summary:
      "Prioritize serious and violent crime and bring greater accountability and transparency to prosecution decisions.",
  },
  {
    id: "law-enforcement",
    icon: BadgeCheck,
    title: "Stand with Delaware Law Enforcement",
    summary:
      "Build a stronger working relationship between the Department of Justice and Delaware's state and local law-enforcement agencies.",
  },
  {
    id: "strengthen-doj",
    icon: Landmark,
    title: "Strengthen the Delaware Department of Justice",
    summary:
      "Address critical staffing needs, recruit and retain qualified prosecutors, and bring effective management and accountability to DOJ operations.",
  },
  {
    id: "seniors-consumers-victims",
    icon: HeartHandshake,
    title: "Protect Seniors, Consumers & Victims",
    summary:
      "Protect Delawareans from fraud, scams and deceptive practices while ensuring victims of crime and abuse are heard, protected and treated with respect.",
  },
  {
    id: "public-trust",
    icon: Scale,
    title: "Restore Accountability & Public Trust",
    summary:
      "Bring transparency, responsible leadership and fair and consistent enforcement of the law to Delaware's Department of Justice.",
  },
];

export const EVENTS = [
  {
    title: "Candidates Forum — Election 2026",
    date: "Thursday, September 17, 2026",
    time: "7:00 PM",
    detail:
      "Dave will appear alongside candidates for U.S. Senate, U.S. House of Representatives, Attorney General, State Treasurer, and Auditor of Accounts. Come hear where he stands.",
    registerUrl: "https://shalomdel.org/candidatesforum2026",
    registerLabel: "Register Online",
  },
];

export const PRESS = [
  {
    title: "Delaware GOP Names Veteran Dave Graham as Attorney General Candidate",
    source: "Delaware Live",
    date: "Campaign Announcement",
    url: "https://delawarelive.com/degop-names-veteran-dave-graham-as-attorney-general-candidate/",
    summary:
      "The Delaware Republican Party names former U.S. Army E-5 Sergeant and retired senior executive Dave Graham as its candidate for Attorney General.",
  },
];

export const BIO_HIGHLIGHTS = [
  {
    badge: "VETERAN LEADERSHIP",
    title: "U.S. Army E-5 Sergeant",
    detail:
      "Dave served his country as a Sergeant in the United States Army, where he learned the discipline, chain-of-command accountability, and mission-first mindset that define his approach to public service.",
  },
  {
    badge: "EXECUTIVE EXPERIENCE",
    title: "Retired Senior Executive",
    detail:
      "As a senior executive, Dave managed complex operations and large teams — answering for budgets, results, and the people who depended on both. He knows how to run a large office and be accountable for it.",
  },
  {
    badge: "WORKING-CLASS ROOTS",
    title: "CDL-A Truck Driver",
    detail:
      "Dave has spent long hours behind the wheel on America's highways. He understands the working families, small businesses, and supply chains that keep Delaware moving — because he's been one of them.",
  },
  {
    badge: "DELAWARE EDUCATION",
    title: "Goldey-Beacom College Graduate",
    detail:
      "A proud graduate of Goldey-Beacom College in Wilmington, Dave built his education right here in Delaware and has called the First State home ever since.",
  },
];
